import * as React from 'react';
import { Body2, Button, Image, RoundButton, UIHeading5 } from '@cian/ui-kit';
import { IconActionClose16, IconCommunicationMessage16 } from '@cian/ui-kit-design-tokens/icons';

import { INewbuildingSummaryCell } from '../../../../../../types/newbuildingsCompare';
import { Link } from '../../../../../Link';
import * as style from './NewbuildingSummaryCellFloating.css';

export interface INewbuildingSummaryCellFloatingProps {
  cell: INewbuildingSummaryCell;
}

export const NewbuildingSummaryCellFloating = ({ cell }: INewbuildingSummaryCellFloatingProps): React.JSX.Element => {
  const { data, state } = cell;

  if (!data) {
    return <Body2>{state.text ?? ''}</Body2>;
  }

  const { name, fullUrl, imageUrl, priceRange, builders, sellers } = data;
  const hasChat = [...builders, ...sellers].some(contact => contact.chat?.enabled);

  return (
    <div className={style['container']}>
      <Image alt={name} borderRadius="8px" height={56} objectFit="cover" src={imageUrl} width={56} />
      <div className={style['content']}>
        <div className={style['facts']}>
          <div className={style['name']}>
            <Link href={fullUrl} target="_blank">
              <UIHeading5 color="text-main-default">{name}</UIHeading5>
            </Link>
          </div>
          {priceRange && (
            <div className={style['price']}>
              <Body2>{priceRange}</Body2>
            </div>
          )}
        </div>
        <div className={style['buttons']}>
          {/* TODO: показать телефон */}
          <Button size="XS" theme="main_primary">
            Показать телефон
          </Button>
          {hasChat && (
            // TODO: открыть чат
            <Button
              beforeIcon={<IconCommunicationMessage16 color="current_color" />}
              size="XS"
              theme="main_primary"
              title="Написать сообщение"
            />
          )}
        </div>
      </div>
      {/* TODO: удаление из сравнения */}
      <RoundButton
        icon={<IconActionClose16 color="icon-secondary-default" />}
        size="XS"
        theme="light"
        title="Удалить из сравнения"
      />
    </div>
  );
};
